// extracted by mini-css-extract-plugin
export default {"mobileList":"VerticalTariffCardList__mobileList--1eBEP","mobileTariff":"VerticalTariffCardList__mobileTariff--tvSVJ"};